@if (isAllow()) {
  <app-switch #switch [checked]="!!item().published" (changeStatus)="onToggle($event, switch)"></app-switch>
} @else if (canSubmit(item()) && isStudentOrResponsible()) {
  @let action = actionFn();
  <button
    app-button
    (click)="action()"
    class="flex-row items-center gap-2 rounded-lg border-black/10 bg-white px-4 text-black border border-solid"
  >
    <svg-icon class="w-5 h-5 flex items-center justify-center" [src]="iconAnswer() | icon"></svg-icon>
    <span class="text-base">{{ labelAnswer() | translate }}</span>
  </button>
}
